import useStorageEvent from '@/hooks/useStorageEvent';
import { getUserPermissions } from '@/utils/auth';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { useState } from 'react';

export const usePermissions = () => {
  const [permissions, setPermissions] = useState(getUserPermissions() ?? []);

  useStorageEvent('permissions', () => {
    setPermissions((oldPermissions) => {
      const newPermissions = getUserPermissions() ?? [];
      if (isEqual(sortBy(oldPermissions), sortBy(newPermissions))) {
        return oldPermissions;
      }
      return newPermissions;
    });
  });

  return { permissions };
};
